import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SectionHeading from "@/components/SectionHeading";
import Gallery from "@/components/Gallery";
import HeroSection from "@/components/HeroSection";

const TehnicniKamen = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <HeroSection
          title="Tehnični kamen"
          subtitle="Trpežen kamen za tehnične rešitve"
          imageSrc="/placeholder.svg"
          primaryButtonText="Zahtevaj ponudbo"
          primaryButtonLink="/kontakt"
        />
        
        <div className="container-custom mx-auto py-16">
          <SectionHeading
            title="Tehnični kamen"
            subtitle="Trpežen kamen za tehnične rešitve"
          />
          
          <div className="mt-8 prose prose-lg max-w-none">
            <p>
              Tehnični kamen združuje najboljše lastnosti naravnega kamna z naprednimi tehnologijami obdelave.
              Rezultat je material, ki je odporen proti obrabi, madežem in visokim temperaturam, zato je idealen za zahtevne površine.
            </p>
          </div>
          
          <Gallery
            images={[
              { src: "/placeholder.svg", alt: "Tehnični kamen 1" },
              { src: "/placeholder.svg", alt: "Tehnični kamen 2" },
              { src: "/placeholder.svg", alt: "Tehnični kamen 3" },
              { src: "/placeholder.svg", alt: "Tehnični kamen 4" },
            ]}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TehnicniKamen;